import * as React from 'react'
import { InputItem } from 'antd-mobile'
import { getTextByKey } from '@feedback/utils/util'
import styles from './index.module.scss'
import { getAppConfig } from '@feedback/utils/CONST'
import { isVestAppid } from '@feedback/utils/siteConfig'
import clsx from 'clsx'

const SearchInput: React.FC<{
  value?: string
  clear?: boolean
  onSearch?: (value: string) => void
  onChange?: (value: string) => void
}> = ({ value, clear, onChange, onSearch }) => {
  const ref = React.useRef<any>()
  const [keyWord, setKeyWord] = React.useState(value || '')
  const { appid } = getAppConfig() || {}
  const isVest = isVestAppid(appid)

  React.useEffect(() => {
    setKeyWord(value || '')
  }, [value])
  React.useEffect(() => {
    onChange?.(keyWord)
  }, [keyWord])

  return (
    <div
      className={clsx(
        styles.search,
        isVest ? styles.vest : styles?.[appid]
      )}
    >
      <InputItem
        ref={ref}
        placeholder={getTextByKey('Search')}
        value={keyWord}
        maxLength={150}
        onChange={(val) => {
          setKeyWord(val)
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && onSearch) {
            onSearch(keyWord)
            ref.current?.inputRef?.inputRef?.blur?.()
          }
        }}
      />
      {clear && keyWord ? (
        <i
          className='icon clear'
          onClick={() => {
            ref.current?.inputRef?.inputRef?.focus?.()
            setKeyWord('')
          }}
        />
      ) : (
        <i className='icon search' onClick={() => onSearch?.(keyWord)} />
      )}
    </div>
  )
}
export default SearchInput
